export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7082.714242aa.jpg";